import Api from '../../classes/Api/Api';
import URL from '../../classes/Url/URL';
import Response from '../../classes/Response/Response';
import Project from '../../classes/Project/Project';

const ChildProjectsService = () => {
  const getChildProjects = async (projectId) => {
    const api = new Api(
      `${URL.URL_SERVER}/projects/${projectId}/properties`
    );
    
    const http_response = await api.get();
    const response = new Response(http_response, Project);
    const { resources: childProjects, count } = response.wasSuccessfull().multiple();
    
    return { childProjects, count };
  };
  
  return {
    getChildProjects,
  };
};

export default ChildProjectsService;